import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function HeroSection() {
  const [t, i18n] = useTranslation("global");
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/service`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });
        const result = await response.json();
        setServices(result?.data || []);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, [i18n.language]);

  return (
    <header style={{ backgroundColor: "#F2F1F0" }}>
      <section className="container hero-section">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-6 col-12">
            <div className="div-text">
              <h1 className="hero-title">{t("hero.title")}</h1>
            </div>
            <div className="div-paragraph">
              <p>{t("hero.description")}</p>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <img
              src="assets/imgs/Group 1410103733.svg"
              width="100%"
              alt="Hero Section"
            />
          </div>
        </div>
        <div>
          <h3 className="main-color text-center  my-4 services-title">
            {t("hero.servicesTitle")}
          </h3>
          <div className="row align-items-center justify-content-center">
  <div className="col-lg-4 col-12 mb-4 text-center">
    <img src="assets/imgs/Branding.svg" alt="Branding" />
    <h4 className="main-color text-center my-1 service-title">
      {services[0]?.name || t("hero.serviceOneTitle")}
    </h4>
    <p className="main-color">
      {services[0]?.description || t("hero.serviceOneDescription")}
    </p>
  </div>
  <div className="col-lg-4 col-12 mb-4 text-center">
    <img src="assets/imgs/Ui Design.svg" alt="UI Design" />
    <h4 className="main-color text-center my-1 service-title">
      {services[1]?.name || t("hero.serviceTwoTitle")}
    </h4>
    <p className="main-color">
      {services[1]?.description || t("hero.serviceTwoDescription")}
    </p>
  </div>
  <div className="col-lg-4 col-12 mb-4 text-center">
    <img src="assets/imgs/Product.svg" alt="Product Design" />
    <h4 className="main-color text-center my-1 service-title">
      {services[2]?.name || t("hero.serviceThreeTitle")}
    </h4>
    <p className="main-color">
      {services[2]?.description || t("hero.serviceThreeDescription")}
    </p>
  </div>
</div>

        </div>
      </section>
    </header>
  );
}

export default HeroSection;
